/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_FooterInputs */

const en_signin_footer = /** @type {(inputs: Signin_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trouble signing in? Ask your workspace admin for help.`)
};

/** @type {(inputs: Signin_FooterInputs) => LocalizedString} */
const ar_signin_footer = en_signin_footer;

/** @type {(inputs: Signin_FooterInputs) => LocalizedString} */
const he_signin_footer = en_signin_footer;

/** @type {(inputs: Signin_FooterInputs) => LocalizedString} */
const ur_signin_footer = en_signin_footer;

/** @type {(inputs: Signin_FooterInputs) => LocalizedString} */
const es_signin_footer = en_signin_footer;

/** @type {(inputs: Signin_FooterInputs) => LocalizedString} */
const fr_signin_footer = en_signin_footer;

/** @type {(inputs: Signin_FooterInputs) => LocalizedString} */
const de_signin_footer = en_signin_footer;

/** @type {(inputs: Signin_FooterInputs) => LocalizedString} */
const pt_signin_footer = en_signin_footer;

/** @type {(inputs: Signin_FooterInputs) => LocalizedString} */
const hi_signin_footer = en_signin_footer;

/** @type {(inputs: Signin_FooterInputs) => LocalizedString} */
const bn_signin_footer = en_signin_footer;

/**
* | output |
* | --- |
* | "Trouble signing in? Ask your workspace admin for help." |
*
* @param {Signin_FooterInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_footer = /** @type {((inputs?: Signin_FooterInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_FooterInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_footer(inputs)
	if (locale === "he") return he_signin_footer(inputs)
	if (locale === "ur") return ur_signin_footer(inputs)
	if (locale === "es") return es_signin_footer(inputs)
	if (locale === "fr") return fr_signin_footer(inputs)
	if (locale === "de") return de_signin_footer(inputs)
	if (locale === "pt") return pt_signin_footer(inputs)
	if (locale === "hi") return hi_signin_footer(inputs)
	if (locale === "bn") return bn_signin_footer(inputs)
	return /** @type {LocalizedString} */ ("Trouble signing in? Ask your workspace admin for help.")
});